import React, { memo } from "react";
const Title = ({ children }: any) => (!!children ? <h1>{children}</h1> : null);
export default memo(Title);
